import {
  ArrangementsAuthData,
  BACK_URL_GET_PARAM,
  ErrorText,
  InventoryAuthData,
  LogoLocation,
  SalesAuthData,
} from './constants';

/**
 * Updates input field value and error in the form state
 * @param  {event}
 * @param  {object} payloadState
 * @param  {(object) => void} setState
 * @param  {(string) => string} checkValueBeforeSet {field validation}
 */
function changeInputHandler({ target }, payloadState = {}, setState, checkValueBeforeSet = (value) => value) {
  const { id, value } = target;
  const newValue = checkValueBeforeSet(value);

  if (newValue === '' || newValue) {
    setState({
      ...payloadState,
      [id]: newValue,
      [`${id}Error`]: false,
      [`${id}ErrorMsg`]: '',
    });
  }
}

function validateField(
  { target: { id = '', value = '' } = {} } = {},
  payloadState = {},
  setState,
  fieldIsValid = () => true,
  invalidMessage = '',
  validateEmptyField = false,
  emptyFieldErrorMessage = ErrorText.FIELD_IS_REQUIRED,
) {
  if (!validateEmptyField && !value) {
    return;
  }

  if (!fieldIsValid(value) || (validateEmptyField && !value)) {
    setState({
      ...payloadState,
      [`${id}Error`]: true,
      [`${id}ErrorMsg`]: validateEmptyField && !value ? emptyFieldErrorMessage : invalidMessage,
    });
  }
}

function clearStorage() {
  localStorage.setItem(SalesAuthData.USER, '');
  localStorage.setItem(SalesAuthData.TOKEN, '');
  localStorage.setItem(InventoryAuthData.USER, '');
  localStorage.setItem(InventoryAuthData.TOKEN, '');
  localStorage.setItem(ArrangementsAuthData.USER, '');
  localStorage.setItem(ArrangementsAuthData.TOKEN, '');
}

function setPromiseAllSettled() {
  Promise.allSettled = (promises) => (
    Promise.all(promises.map((p) => Promise.resolve(p).then((value) => ({
      status: 'fulfilled',
      value,
    }), (error) => ({
      status: 'rejected',
      reason: error,
    }))))
  );
}

function getCemeteryLogoProps(location, isTextSeparated) {
  const smallLogoSrc = location === LogoLocation.HEADER ? '/logos/logo-small-colored.svg' : '/logos/logo-small-white.svg';
  const fullLogoSrc = location === LogoLocation.HEADER ? '/logos/logo-header.svg' : '/logos/logo-big.svg';
  const separatedLogoWidth = location === LogoLocation.HEADER ? 40 : 160;
  const fullLogoWidth = location === LogoLocation.HEADER ? 'auto' : 260;
  const separatedLogoHeight = location === LogoLocation.HEADER ? 40 : 152;
  const logoClasses = `cemetery-logo__img ${isTextSeparated ? 'cemetery-logo__img_with-text' : ''}`;
  const logoSrc = isTextSeparated ? smallLogoSrc : fullLogoSrc;
  const logoWidth = isTextSeparated ? separatedLogoWidth : fullLogoWidth;
  const logoHeight = isTextSeparated ? separatedLogoHeight : 'auto';

  return {
    logoClasses,
    logoSrc,
    logoWidth,
    logoHeight,
  };
}

function getSearchParam(key) {
  return new URLSearchParams(window.location.search).get(key);
}

function getBackUrl() {
  const backUrl = getSearchParam(BACK_URL_GET_PARAM);

  if (!backUrl) {
    return '';
  }

  try {
    return atob(backUrl);
  } catch {
    return backUrl;
  }
}

export {
  changeInputHandler,
  clearStorage,
  getBackUrl,
  getCemeteryLogoProps,
  getSearchParam,
  setPromiseAllSettled,
  validateField,
};
